import { NORMAL, PERSONNALISE } from '@/configuration/devisConf';

export default function checkLignesRegroupementPersoWithSameEcheancier(
  lignesCommandes, referenceRegroupementPerso,
) {
  const lignesRegroupementPerso = lignesCommandes.filter((ligne) => {
    return ligne.referencePersonnalise === referenceRegroupementPerso
      && ligne.type !== PERSONNALISE;
  });
  let lignes = [];
  lignesRegroupementPerso.forEach((ligne) => {
    if (ligne.type === NORMAL) lignes.push(ligne);
    if (ligne.lignesCommande) {
      lignes = lignes.concat(
        ligne.lignesCommande.filter((ligneEnfant) => {
          return ligneEnfant.type === NORMAL;
        }),
      );
    }
  });
  const referenceEcheancier = lignes[0].referenceEcheancier;
  return lignes.every((ligne) => { return ligne.referenceEcheancier === referenceEcheancier; });
}
